import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { RepresentanteModalidadeComercialPipeModule } from '../../../pipes/modalidade-comercial';

import { RepresentanteModalidadeComercialSelectComponent } from './representante-modalidade-comercial-select.component';

@NgModule({
    imports: [
        SharedModule,
        RepresentanteModalidadeComercialPipeModule
    ],
    declarations: [
        RepresentanteModalidadeComercialSelectComponent
    ],
    exports: [
        RepresentanteModalidadeComercialSelectComponent
    ]
})
export class RepresentanteModalidadeComercialSelectModule { }
